import { useRef, useCallback } from "react";

// Loop house anni '90 sintetizzato: cassa in 4/4, hi-hat in controtempo, bassline e pad.
const useHouseLoop = () => {
  const ctxRef = useRef(null);
  const timerRef = useRef(null);
  const masterRef = useRef(null);

  const stop = useCallback(() => {
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    if (ctxRef.current) { ctxRef.current.close().catch(() => {}); ctxRef.current = null; }
  }, []);

  const start = useCallback((bpm = 120) => {
    stop();
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    ctxRef.current = ctx;
    const master = ctx.createGain();
    master.gain.value = 0.16;
    master.connect(ctx.destination);
    masterRef.current = master;

    const beat = 60 / bpm;
    let step = 0;
    let nextTime = ctx.currentTime + 0.1;
    const bassNotes = [55, 55, 65.4, 55, 49, 55, 73.4, 65.4];

    const kick = (t) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.frequency.setValueAtTime(150, t);
      o.frequency.exponentialRampToValueAtTime(45, t + 0.11);
      g.gain.setValueAtTime(0.9, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.24);
      o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.26);
    };
    const hat = (t, open = false) => {
      const len = open ? 0.18 : 0.05;
      const buffer = ctx.createBuffer(1, ctx.sampleRate * len, ctx.sampleRate);
      const d = buffer.getChannelData(0);
      for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
      const src = ctx.createBufferSource(); src.buffer = buffer;
      const f = ctx.createBiquadFilter(); f.type = "highpass"; f.frequency.value = 7500;
      const g = ctx.createGain(); g.gain.value = open ? 0.22 : 0.14;
      src.connect(f); f.connect(g); g.connect(master); src.start(t);
    };
    const bass = (t, freq) => {
      const o = ctx.createOscillator(); o.type = "sawtooth"; o.frequency.value = freq;
      const f = ctx.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 300; f.Q.value = 6;
      const g = ctx.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.32, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, t + beat * 0.45);
      o.connect(f); f.connect(g); g.connect(master); o.start(t); o.stop(t + beat * 0.5);
    };
    const pad = (t) => {
      [220, 261.6, 329.6].forEach((freq) => {
        const o = ctx.createOscillator(); o.type = "sawtooth";
        o.frequency.value = freq * (1 + (Math.random() - 0.5) * 0.004);
        const f = ctx.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 900;
        const g = ctx.createGain();
        g.gain.setValueAtTime(0.0001, t);
        g.gain.linearRampToValueAtTime(0.035, t + beat * 2);
        g.gain.linearRampToValueAtTime(0.0001, t + beat * 7.8);
        o.connect(f); f.connect(g); g.connect(master); o.start(t); o.stop(t + beat * 8);
      });
    };

    const scheduler = () => {
      while (nextTime < ctx.currentTime + 0.25) {
        const t = nextTime;
        const s = step % 8;
        if (s % 2 === 0) kick(t);
        if (s % 2 === 1) hat(t, s === 7);
        if (s !== 0) bass(t, bassNotes[s]);
        if (step % 16 === 0) pad(t);
        step++;
        nextTime += beat / 2;
      }
    };
    timerRef.current = setInterval(scheduler, 90);
    scheduler();
  }, [stop]);

  return { start, stop };
};

export default useHouseLoop;
